import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import Button from '../Button'
import Icon from '../../Icon'

class Select extends PureComponent {
  render () {
    const classNames = ['Select']
    if (this.props.type) {
      classNames.push('Select-' + this.props.type)
    }

    let label = ''
    if (this.props.label !== undefined) {
      label = <label>{this.props.label + (this.props.required ? ' *' : '')}</label>
    }

    let message
    if (this.props.valid !== true) {
      if (this.props.message) {
        message = <span>{this.props.message}</span>
      }
      classNames.push('SelectError')
    }

    const options = this.props.options
    if (this.props.placeholder !== '' && !this.props.selected) {
      options.unshift({ value: '', label: this.props.placeholder })
    }

    const value = (this.props.selected === null || this.props.selected === undefined) ? '' : this.props.selected
    let hasHiddenOption = true
    const optionComponents = options.map((option) => {
      const optionValue = this.props.optionValueKey ? get(option, this.props.optionValueKey, undefined) : option.value
      if (typeof option.value === 'undefined' || option.value === '' || option.value === null) {
        hasHiddenOption = false
      }
      const optionLabel = this.props.optionLabelKey ? get(option, this.props.optionLabelKey, '?') : option.label
      return (
        <option
          value={optionValue} key={optionValue}
        >{optionLabel}</option>
      )
    })
    return (
      <div>
        {label} {message}
        <div className={'select-wrap'}>
          <select className={classNames.join(' ')}
                  disabled={this.props.disabled}
                  value={value}
                  onChange={this.props.onChange}>
            {hasHiddenOption && <option disabled hidden value={null}/>}
            {optionComponents}
          </select>
          {this.props.clearable && value !== '' &&
          <Button classNames={'Button-Select-Append'} onClick={this.props.onClear}>
            <Icon type={'fa'} faClassName={'fa-remove'}/></Button>}
        </div>
      </div>
    )
  }
}

Select.defaultProps = {
  placeholder: '',
  required: false,
  disabled: false,
  valid: true
}

Select.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  onClear: PropTypes.func,
  selected: PropTypes.any,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  valid: PropTypes.bool,
  message: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  optionLabelKey: PropTypes.any,
  optionValueKey: PropTypes.any
}

export default Select
